import React from 'react';
import { useSelector } from 'react-redux';

const useDocumentSelectors = () => {
  const listDocumentType = useSelector(
    (store) => store.newDocumentStore.listDocumentType
  );
  const listDocumentOrdSubtype = useSelector(
    (store) => store.newDocumentStore.listOrdType
  );
  const listDocumentOssSubtype = useSelector(
    (store) => store.newDocumentStore.listOssType
  );
  const listDocumentContractSubtype = useSelector(
    (store) => store.newDocumentStore.listContractType
  );
  const listServiceCompanies = useSelector(
    (store) => store.newDocumentStore.listServiceCompanies
  );
  const listExecuter = useSelector(
    (store) => store.newDocumentStore.listExecuter
  );
  const responsibleWorkers = useSelector(
    (store) => store.newDocumentStore.responsibleWorkers
  );
  const listAddrStreet = useSelector(
    (store) => store.newDocumentStore.listAddrStreet
  );

  return (
    {
      listDocumentType,
      listDocumentOrdSubtype,
      listDocumentOssSubtype,
      listDocumentContractSubtype,
      listServiceCompanies,
      listExecuter,
      responsibleWorkers,
      listAddrStreet
    }
  );
};

export default useDocumentSelectors;